module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres4ax"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "unLoadBool": true,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "receivedStore": _vm.receivedHres4axIndex,
      "detailEvent": _vm.detailEvent,
      "searchBoxAlias": "hres4ax"
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), (_vm.detailDisp) ? _c('detail', {
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "detail": _vm.detail,
      "toggle": _vm.toggle,
      "indexSelected": _vm.indexSelected,
      "receivedOrgBodyDetail": _vm.receivedOrgBodyDetail
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    ref: "hres4axPopup1",
    staticClass: "hidden btn bg-color-skin pull-right",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#hres4ax-popup1"
    }
  }), _vm._v(" "), _c('popup1', {
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "popup1": _vm.popup1,
      "popup1Tab1Table": _vm.columns[_vm.app.nowLang].popup1Tab1Table,
      "popup1Tab2Table": _vm.columns[_vm.app.nowLang].popup1Tab2Table,
      "popup1Tab3Table": _vm.columns[_vm.app.nowLang].popup1Tab3Table,
      "detail": _vm.detail,
      "popup2": _vm.popup2,
      "popup2Tab2Table": _vm.columns[_vm.app.nowLang].popup2Tab2Table,
      "popup2Tab3Table": _vm.columns[_vm.app.nowLang].popup2Tab3Table
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d588130c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres4ax/component.vue
// module id = 3984
// module chunks = 1